import React from 'react';
import PropTypes from 'prop-types';
import DesktopSidebar from './DesktopSidebar';
import MobileSidebar from './MobileSidebar';
import styles from './Sidebar.module.scss';

const Sidebar = React.memo(({ menuActived, menuDesktopActived }) => {
  return (
    <div className={`sidebar-wrapper ${styles.wrapper}`}>
      <DesktopSidebar menuActived={menuDesktopActived} />
      <MobileSidebar menuActived={menuActived} />
    </div>
  );
});

Sidebar.defaultProps = {
  menuActived: false,
  menuDesktopActived: true,
};

Sidebar.propTypes = {
  menuActived: PropTypes.bool,
  menuDesktopActived: PropTypes.bool,
};

export default Sidebar;
